var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31299 20.0278C8.60923 20.036 8.88239 19.8684 9.01025 19.601L15.0405 6.99166L17.521 12.4096L17.5737 12.5044C17.7105 12.7158 17.946 12.847 18.2026 12.8471H23.0005L23.0776 12.8432C23.4556 12.8046 23.7505 12.4853 23.7505 12.0971C23.7504 11.709 23.4556 11.3896 23.0776 11.351L23.0005 11.3471H18.6851L15.7378 4.90963C15.6165 4.6452 15.3529 4.47458 15.062 4.47213C14.7711 4.46982 14.5049 4.63638 14.3794 4.89889L8.38428 17.4321L6.07178 11.812C5.95608 11.5309 5.68139 11.3471 5.37744 11.3471H1.00049C0.586311 11.3471 0.250547 11.683 0.250488 12.0971C0.250488 12.5113 0.586275 12.8471 1.00049 12.8471H4.87549L7.64014 19.563L7.68896 19.6616C7.81903 19.8802 8.05369 20.0206 8.31299 20.0278Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvg);
export default __webpack_public_path__ + "static/media/Avg.c716c758fc67462140b1ae4fb8660ee7.svg";
export { ForwardRef as ReactComponent };